/**
 * @file tag-helper.ts
 * @description Утилиты для управления тегами в Task Manager приложении. Предоставляет функции для создания, сохранения и удаления тегов через ObjectFormService API с обработкой ошибок Axios для системы категоризации и маркировки задач, проектов и других сущностей.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '@api/actions', 'axios']
 * @related-files ['src/components/ui/tags', 'src/forms', 'src/api/actions/object-form.ts']
 */

import { TBaseObjectDto } from '@src/types';
import { ObjectFormService } from '@api/actions';
import axios from 'axios';

/**
 * Проверяет, является ли ответ ошибкой Axios
 * @param response - ответ от API
 * @returns true если ответ является ошибкой
 */
const isApiError = (response: any): boolean => {
    return axios.isAxiosError(response);
};

/**
 * Удаляет тег по идентификатору
 * @param type - тип объекта
 * @param tagId - идентификатор тега для удаления
 * @returns true при успешном удалении, false при ошибке
 */
export const deleteTag = async (type: string, tagId: string): Promise<boolean> => {
    const response = await ObjectFormService.delete(type, { id: tagId });
    return !isApiError(response);
};

/**
 * Сохраняет существующий тег
 * @param tag - объект тега для сохранения
 * @returns true при успешном сохранении, false при ошибке
 */
export const saveTag = async (tag: TBaseObjectDto): Promise<boolean> => {
    const response = await ObjectFormService.save(tag.$type, tag);
    return !isApiError(response);
};

/**
 * Создает новый тег
 * @param tag - объект нового тега
 * @returns true при успешном создании, false при ошибке
 */
export const createTag = async (tag: TBaseObjectDto): Promise<boolean> => {
    const response = await ObjectFormService.create(tag.$type, tag);
    return !isApiError(response);
};
